import { useEffect } from "react";
import { DatePicker, Form } from "antd";
import dayjs from "dayjs";
import {
  fromIsoToPickerValue,
  getExpiryDefaultTime,
} from "../commons/discountCodes.helpers";
import { CODES_COPY } from "../commons/discountCodes.copy";

const DATE_FORMAT = "MMM D, YYYY HH:mm";

const nowAsPickerValue = () => fromIsoToPickerValue(dayjs().toISOString());

/**
 * Dates of the new run inside the Run again confirm (ui-spec §2.1.4): optional
 * start, required expiry. `onReady(form)` hands the form to the confirm's OK.
 */
function RunAgainFields({ initialValues, onReady }) {
  const [form] = Form.useForm();

  useEffect(() => {
    onReady?.(form);
  }, [form, onReady]);

  const disabledDate = (d, info) =>
    info?.type === "date" ? d && d < dayjs().startOf("day") : false;

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      requiredMark={false}
      className="mt-4"
    >
      <Form.Item
        name="starts_at"
        label={CODES_COPY.fieldStarts}
        extra={CODES_COPY.fieldStartsExtra}
      >
        <DatePicker
          showTime={{ format: "HH:mm" }}
          format={DATE_FORMAT}
          disabledDate={disabledDate}
          style={{ width: "100%" }}
          onChange={() => form.validateFields(["expires_at"])}
        />
      </Form.Item>
      <Form.Item
        name="expires_at"
        label={CODES_COPY.fieldExpires}
        extra={CODES_COPY.fieldExpiresExtra}
        rules={[
          { required: true, message: CODES_COPY.fieldExpiresErr },
          {
            validator(_, v) {
              if (!v) return Promise.resolve();
              if (!dayjs(v).isAfter(nowAsPickerValue()))
                return Promise.reject(
                  new Error(CODES_COPY.runAgainExpiresPast)
                );
              const start = form.getFieldValue("starts_at");
              if (start && !dayjs(v).isAfter(start))
                return Promise.reject(
                  new Error(CODES_COPY.fieldExpiresBeforeStart)
                );
              return Promise.resolve();
            },
          },
        ]}
      >
        <DatePicker
          showTime={{
            format: "HH:mm",
            defaultOpenValue: getExpiryDefaultTime(),
          }}
          format={DATE_FORMAT}
          disabledDate={disabledDate}
          style={{ width: "100%" }}
        />
      </Form.Item>
    </Form>
  );
}

export default RunAgainFields;
